import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const PiechartExpenses = ({ data, colors }) => {
  const COLORS = ["#9A4A9C", "#5B489D", "#FFB347", "#76D7C4", "#F7DC6F"];
  let mapData = [];
  let hasData = false;
  if (data && data.length > 0) {
    mapData = data.map(({ expense_type, amount }) => ({
      name: expense_type,
      value: amount,
      color: colors[expense_type],
    }));
    // Check if there's at least one non-zero value
    hasData = mapData.some((item) => item.value > 0);
  }

  const defaultData = [{ name: "No Data", value: 1 }];

  const DEFAULT_COLOR = "#dddddd"; // Default color for no data

  // Custom tooltip content rendering function
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          <p>{data.name}</p>
          <p>
            <strong>Count:</strong> {data.value}
          </p>
        </div>
      );
    }

    return null;
  };
  return (
    <ResponsiveContainer width="100%" height={250}>
      <PieChart>
        <Pie
          data={hasData ? mapData : defaultData}
          dataKey="value"
        //   nameKey="expense_type"
          cx="50%"
          cy="50%"
          outerRadius={100}
        //   label
        >
          {(hasData ? mapData : defaultData).map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={hasData && entry.color ? entry.color : DEFAULT_COLOR}
            />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default PiechartExpenses;
